module.exports = __webpack_public_path__ + "static/media/instagram.bb012c37.png";